import { AfterViewInit, Component, Input, OnChanges, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import CustomValidators from '../../../shared/custom-validators';
import { PartnerOption } from '../../../shared/models/options/partner-option.model';
import { OptionTypes } from '../../../shared/models/options/option-types.model';
import { SessionStorageService } from '../../../services/session-storage.service';
import { PartnerService } from '../../../services/partner.service';
import { finalize } from 'rxjs';
import { PartnerFrontChannelComponent } from '../partner-front-channel/partner-front-channel.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

const MOCK_PASSWORD = '';

@Component({
  selector: 'app-components-manager-partner-notification-settings',
  templateUrl: './partner-notification-settings.component.html'
})
export class PartnerNotificationSettingsComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('provisionTextMessageNumberModal') provisionTextMessagePhoneNumberModal: TemplateRef<any>;
  @Input() partner: Boo.Objects.Partner;
  @Input() options: PartnerOption<any>[];
  loading = false;
  notificationSettingsForm: UntypedFormGroup;
  skipOnsiteBloggingApproval: boolean;
  skipOnsiteCopyApproval: boolean;
  skipOnsiteRecommendationApproval: boolean;
  @ViewChild(PartnerFrontChannelComponent) frontChannelComponentRef: PartnerFrontChannelComponent;

  private partnerDefaults: Boo.Objects.PartnerDefaults;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private partnerService: PartnerService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges(): void {
    this.skipOnsiteBloggingApproval = this.options.find(o => o.OptionId === OptionTypes.skipOnsiteBloggingApproval).Values;
    this.skipOnsiteCopyApproval = this.options.find(o => o.OptionId === OptionTypes.skipOnsiteCopyApproval).Values;
    this.skipOnsiteRecommendationApproval = this.options.find(o => o.OptionId === OptionTypes.skipOnsiteRecommendationApproval).Values;
  }

  ngAfterViewInit(): void {
    this.notificationSettingsForm.controls['onboardingSchedulingLink'].updateValueAndValidity();
    this.notificationSettingsForm.controls['schedulingLink'].updateValueAndValidity();
    this.notificationSettingsForm.controls['skipOnsiteBloggingApproval'].updateValueAndValidity();
    this.notificationSettingsForm.controls['skipOnsiteCopyApproval'].updateValueAndValidity();
    this.notificationSettingsForm.controls['skipOnsiteRecommendationApproval'].updateValueAndValidity();
  }

  private initForm(): void {
    // init form
    this.notificationSettingsForm = this.formBuilder.group({
      schedulingLink: [this.partner.SchedulingLink, [Validators.required, CustomValidators.validUrl()]],
      onboardingSchedulingLink: [this.partner.OnboardingSchedulingLink, [Validators.required, CustomValidators.validUrl()]],
      skipOnsiteBloggingApproval: [this.skipOnsiteBloggingApproval],
      skipOnsiteCopyApproval: [this.skipOnsiteCopyApproval],
      skipOnsiteRecommendationApproval: [this.skipOnsiteRecommendationApproval],
      allowsTextMessaging: [this.partner.AllowsTextMessaging],
      textMessagingPhoneNumber: [this.partner.TextMessagingPhoneNumber]
    });

    // subscribe to form changes
    this.notificationSettingsForm.controls['schedulingLink'].valueChanges.subscribe(value => this.partner.SchedulingLink = value);
    this.notificationSettingsForm.controls['onboardingSchedulingLink'].valueChanges.subscribe(value => this.partner.OnboardingSchedulingLink = value);
    this.notificationSettingsForm.controls['skipOnsiteBloggingApproval'].valueChanges.subscribe(value => this.options.find(o => o.OptionId === OptionTypes.skipOnsiteBloggingApproval).Values = value);
    this.notificationSettingsForm.controls['skipOnsiteCopyApproval'].valueChanges.subscribe(value => this.options.find(o => o.OptionId === OptionTypes.skipOnsiteCopyApproval).Values = value);
    this.notificationSettingsForm.controls['skipOnsiteRecommendationApproval'].valueChanges.subscribe(value => this.options.find(o => o.OptionId === OptionTypes.skipOnsiteRecommendationApproval).Values = value);

    this.notificationSettingsForm.controls['allowsTextMessaging'].valueChanges.subscribe(value => {
      this.partner.AllowsTextMessaging = value;
      if (value) {
        this.provisionTextMessagePhoneNumber();
      } else {
        this.notificationSettingsForm.get('textMessagingPhoneNumber').setValue(null);
      }
    });

    this.notificationSettingsForm.controls['textMessagingPhoneNumber'].valueChanges.subscribe(value => this.partner.TextMessagingPhoneNumber = value);

    this.notificationSettingsForm.markAllAsTouched();
  }

  private provisionTextMessagePhoneNumber(): void {
    this.modalService.open(this.provisionTextMessagePhoneNumberModal).result
      .then(() => {
        this.partnerService.provisionTextMessagingPhoneNumber(this.partner.PartnerId).subscribe(x => {
          this.notificationSettingsForm.get('allowsTextMessaging').setValue(!!x);
          this.notificationSettingsForm.get('textMessagingPhoneNumber').setValue(x);
        });
      }, () => {
        this.notificationSettingsForm.get('allowsTextMessaging').setValue(false);
      });
  }
}
